/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ChatThreadRosterMember = zod.object({
  memberId: zod
    .uuid()
    .describe(
      "The Reach member id: for memberType 'user' a Reach user id — batch these into POST \/participants\/resolve for names — for 'agent' a Reach agent id",
    ),
  memberType: zod.enum(['user', 'agent']),
  role: zod.enum(['owner', 'writer', 'reader']),
});

export type ChatThreadRosterMember = zod.input<typeof ChatThreadRosterMember>;
export type ChatThreadRosterMemberOutput = zod.output<typeof ChatThreadRosterMember>;
